/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export function OrganizationPaymentLimitFromJSON(json) {
    return OrganizationPaymentLimitFromJSONTyped(json, false);
}
export function OrganizationPaymentLimitFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        finite: json['finite'],
        value: json['value']
    };
}
export function OrganizationPaymentLimitToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        finite: value.finite,
        value: value.value
    };
}
